import { FileQuestion } from "lucide-react";

export function NotFound() {
  return (
    <div className="container mx-auto py-12 px-4">
      <div className="text-center">
        <FileQuestion className="h-16 w-16 mx-auto text-muted-foreground mb-4" />
        <h2 className="text-2xl font-semibold mb-2">Page introuvable</h2>
        <p className="text-muted-foreground mb-6">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
      </div>
    </div>
  );
}
